export const GTM_PRODUCT_FILTERS = 'gtm-product-filters'
export const RESET_FILTER = 'reset filter'
export const CLICK_FILTER = 'click filter'
export const RANGE_MIN = 'Range min'
export const RANGE_MAX = 'Range max'
export const GTM_RANGE = 'Range'
export const RANGE_SALE_ITEMS = 'Sale items'
export const COLOR_ATTRIBUTE_ID = 9

export const AVAILABLE_FILTERS = {
  attributes: {},
  pager: ['page', 'size'],
  price: ['min', 'max', 'saleItems'],
  sizes: [],
  sizeKeys: [],
}

export enum FILTER_FLAT {
  SIZES = 'sizes',
}

export enum FILTER_RANGE {
  PRICE = 'price',
}
